import { Reducer } from 'redux';
import { makeid } from '../../../utils/formatStrings';
import { IToast, IToastState, Types } from './types';

const INITIAL_STATE: IToastState = {
  toasts: []
};

type CustomAction = {
  type: Types;
  payload: {
    toast: IToast;
  };
};

const reducer: Reducer<IToastState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.ADD_TOAST:
      return {
        ...state,
        toasts: [
          ...state.toasts,
          {
            ...action.payload.toast,
            id: makeid(8)
          }
        ]
      };

    case Types.REMOVE_TOAST:
      return {
        ...state,
        toasts: state.toasts.filter(
          (toast) => toast.id !== action.payload.toast.id
        )
      };

    default:
      return state;
  }
};

export default reducer;
